import { alpha, useTheme } from "@mui/material/styles";
import { FC, Fragment, useState } from "react";

import {
  useTable,
  Column,
  HeaderGroup,
  Row,
  Cell,
  useGlobalFilter,
  useFilters,
  useSortBy,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { GlobalFilter } from "utils/react-table";
import { Add } from "iconsax-react";
import { HeaderSort, TablePagination } from "components/third-party/ReactTable";

import { useAsyncDebounce } from "react-table";
import MainCard from "components/MainCard";
import ScrollX from "components/ScrollX";
import AlertDelete from "components/commons/AlertDelete";
import { Alert } from "@mui/material";

interface Props {
  style?: {};
  addTitle?: string;
  info?: string;
  showAddButton?: boolean;
  columns: Column[];
  renderRowSubComponent?: FC<any>;
  isLoading?: boolean;
  list: any;
  item?: any;
  last_page: number | any;
  pageNumber: number;
  limit: number;
  handleAdd: (e: any) => void;
  handleSearch?: (e: any) => void;
  handleRowSelect?: (e: any) => void;
  showSearch?: boolean;
  showPagination?: boolean;
  deleteProps: {
    title: string;
    alertPopup: boolean;
    handleClose: (status: boolean) => void;
  };
  pageProps: {
    handleGoToPage: (pageNumber: number) => void;
    handleSetPageSize: (pageSize: number) => void;
  };
}

const CommonList = ({
  addTitle = "",
  showAddButton = true,
  columns,
  list,
  pageNumber = 1,
  last_page = 0,
  limit = 10,
  deleteProps,
  handleAdd,
  handleSearch,
  pageProps,
  renderRowSubComponent,
  info = "",
  showSearch = true,
  isLoading = false,
  showPagination = true,
  handleRowSelect,
  style,
}: Props) => {
  const [search, setSearch] = useState("");
  const [filterValues, setFilterValues] = useState<any>({});
  const theme = useTheme();
  const handleFilterChange = (key:number, value:any="") => {
    setFilterValues((prev:any)=> ({ ...prev, [key]: value }));
    console.log(key, value);
    
  };
  console.debug("list: ", list);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      list,
      initialState: { pageIndex: 0, sortBy: [], hiddenColumns: ["draft"] },
      data: list,
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const handleSearching = useAsyncDebounce((value) => {
    setSearch(value.target.value);
    if (handleSearch) {
      handleSearch(value.target.value);
    }
    console.log(search);
  }, 200);

  if (isLoading) {
    return (
      <Box sx={{ width: "100%", flexGrow: 1 }} justifyContent={"start"}>
        <Skeleton sx={{ height: ` 150px`, flexGrow: 1 }} />
        <Skeleton animation="wave" sx={{ height: ` 75px`, flexGrow: 1 }} />
        <Skeleton animation="wave" sx={{ height: ` 75px`, flexGrow: 1 }} />
        <Skeleton animation="wave" sx={{ height: ` 75px`, flexGrow: 1 }} />
        <Skeleton sx={{ height: ` 120px`, flexGrow: 1 }} />
      </Box>
    );
  }

  return (
    <>
      <MainCard content={false} style={style}>
        <ScrollX>
          <Stack>
            {showSearch && (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ p: 3, pb: 0 }}
                marginBottom={3}
              >
                <GlobalFilter
                  preGlobalFilteredRows={[]}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  placeholder="Search "
                  onChangeCapture={handleSearching}
                />

                <Stack direction="row" alignItems="center" spacing={1}>
                  {/* <SortingSelect sortBy={'id'} allColumns={[]} setSortBy={function (sortBy: SortingRule<{}>[]): void {
                                        throw new Error('Function not implemented.');
                                    } } /> */}
                  {showAddButton ? (
                    <Button
                      variant="contained"
                      startIcon={<Add />}
                      onClick={handleAdd}
                      size="large"
                    >
                      Add {addTitle}
                    </Button>
                  ) : (
                    <></>
                  )}
                </Stack>
              </Stack>
            )}
            {info && (
              <Stack marginBottom={0}>
                <Alert severity="info">{info}</Alert>
              </Stack>
            )}
            <Table {...getTableProps()}>
              <TableHead>
                {headerGroups.map((headerGroup: HeaderGroup<{}>, index) => (
                  <TableRow
                    {...headerGroup.getHeaderGroupProps()}
                    sx={{ "& > th:first-of-type": { width: "58px" } }}
                    key={index}
                  >
                    {headerGroup.headers.map((column: HeaderGroup|any, index) => (
                      <TableCell
                        {...column.getHeaderProps([
                          { className: column.className },
                        ])}
                        key={index}
                      >
                         
                        <HeaderSort column={column} sort />
                         { column.selectFilter && <Select
                  value={filterValues[index]?? ""}
                  onChange={(event:any)=>{
                   
                      handleFilterChange(index,event.target.value)
                      column.onSelectFilter(event.target.value,index);
                  //  console.log(event.target.value,filterValues);

                  }}
                  label="Status Filter"
                >
                  <MenuItem value="''">All</MenuItem>
                  {column.selectFilter?.map((filter:any)=>{
                  return <MenuItem value={filter.value}>{filter.title}</MenuItem>

                  })}
                  {/* <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem> */}
                </Select>}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableHead>
              <TableBody {...getTableBodyProps()}>
                {rows?.map((row: Row, i: number) => {
                  prepareRow(row);
                  // const rowProps = row.getRowProps();

                  return (
                    <Fragment key={i}>
                      <TableRow
                        {...row.getRowProps()}
                        onClick={() => {
                          // row.toggleRowSelected();
                          if (handleRowSelect) {
                            handleRowSelect(row.original);
                          }
                        }}
                        sx={{
                          cursor: "pointer",
                          bgcolor: row.isSelected
                            ? alpha(theme.palette.primary.lighter, 0.35)
                            : "inherit",
                        }}
                        key={i}
                      >
                        {row.cells.map((cell: Cell, index) => (
                          <TableCell
                            {...cell.getCellProps([
                              { className: cell.column.className },
                            ])}
                            key={index}
                          >
                            {cell.render("Cell")}
                          </TableCell>
                        ))}
                      </TableRow>
                      {row.isExpanded &&
                        (renderRowSubComponent
                          ? renderRowSubComponent({ row })
                          : false)}
                    </Fragment>
                  );
                })}
                {showPagination && <TableRow
                  sx={{ "&:hover": { bgcolor: "transparent !important" } }}
                >
                  <TableCell sx={{ p: 2, py: 3 }} colSpan={9}>
                    <TablePagination
                      gotoPage={pageProps.handleGoToPage}
                      rows={rows}
                      setPageSize={pageProps.handleSetPageSize}
                      pageSize={limit}
                      pageIndex={pageNumber - 1}
                      totalPages={last_page}
                    />
                  </TableCell>
                </TableRow>}
              </TableBody>
            </Table>
          </Stack>
        </ScrollX>
      </MainCard>
      <AlertDelete
        desc={`${deleteProps ? deleteProps?.title : ""}`}
        open={deleteProps.alertPopup}
        handleClose={deleteProps.handleClose}
      />
    </>
  );
};

export default CommonList;
